import { Visibility } from 'globalTypes'

import ShareContext from 'Root/Contexts/Share'
import apolloClient from 'lib/apollo-client'

import MUTATION from './generate-authorization-token-for-folder.graphql'

const ShareWrapper = ({ children, folder }) => {
  const link = `/f/${folder.slug}`

  let callback
  if (Visibility.protected === folder.visibility && folder.canManage) {
    callback = async () => {
      const { data } = await apolloClient.mutate({
        mutation: MUTATION,
        variables: {
          id: folder.id,
        },
      })

      return `${link}?token=${data.token}`
    }
  }

  const value = {
    callback,
    canManage: folder.canManage,
    text: folder.description || undefined,
    title: folder.title || undefined,
    visibility: folder.visibility || undefined,
    url: link,
  }

  return <ShareContext.Provider value={value}>{children}</ShareContext.Provider>
}

export default ShareWrapper
